import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './LoginPage.css';

const LoginPage = () => {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await axios.post('https://krimaanapp-4.onrender.com/api/login', { id, password }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      navigate(`/farmer/${id}`);
    } catch (err) {
      setError('Invalid credentials');
    }
  };

  return (
    <div data-aos = 'fade-up' data-aos-duration= '1000'className="login-page">
      <h1 className = 'Header_for_login'>Farmers Login</h1>
      <input placeholder="Farmer's Id" value={id} onChange={(e) => setId(e.target.value)} />
      <input placeholder="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      {error && <p className="error">{error}</p>}
      <button onClick={handleLogin}>Login</button>
      <div className='not_with_us'>
      <p>Not Yet with Us? </p>
      <button onClick={() => navigate('/register')}>Register here</button>
      </div>
    </div>
  );
};

export default LoginPage;
